import { Component, OnInit } from '@angular/core';
import { CompetenciesService } from '../competencies.service';

@Component({
  selector: 'app-audits',
  templateUrl: './audits.component.html',
  styleUrls: ['./audits.component.css']
})
export class AuditsComponent implements OnInit {

  constructor(private compservice:CompetenciesService) {   }
  serviceid: number;

  ngOnInit() {
    this.compservice.serviceline$.subscribe(x => {
      this.serviceid = x;
  })

}
}